import _extends from "@babel/runtime/helpers/esm/extends";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../../index';
import { Tag, Content, Name, CloseIcon } from './userTag.styles';
function UserTag(_ref) {
  let {
    name,
    apmid,
    onRemoveTag
  } = _ref;
  return _jsxs(Tag, _extends({
    onClick: () => onRemoveTag(apmid)
  }, {
    children: [_jsx(Content, {
      children: _jsxs(Name, {
        children: [name, _jsxs("span", {
          children: ["(", apmid, ")"]
        })]
      })
    }), _jsx(CloseIcon, {
      children: _jsx(Icon, {
        size: "20",
        name: "times-circle"
      })
    })]
  }));
}
export default UserTag;